import { styled } from '@project44/manifest-ds';

export const Item = styled('div', {
  padding: '$medium',
  borderBottom: '1px solid $border-primary',
  '&:last-child': {
    borderBottom: '0 none',
  },
});

export const IconsContainer = styled('div', {
  color: '$text-danger',
  display: 'inline-flex',
  '& > *': {
    marginRight: '$small',
    '&:last-child': {
      marginRight: 0,
    },
  },
});
